(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/pages/games-page.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/pages/games-page.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const Games = svs.numbergames.fractiongames.components.Games;
const actions = svs.numbergames.fractiongames.redux.actions;
const GamesPage = () => {
  const dispatch = useDispatch();
  const _useParams = useParams(),
    productFilter = _useParams.productParam;
  useEffect(() => {
    dispatch(actions.socketSubscribe());
    return () => {
      dispatch(actions.socketUnsubscribe());
    };
  }, [dispatch]);
  return React.createElement(Games, {
    productFilter: productFilter
  });
};
svs.fractiongames.pages.GamesPage = GamesPage;

 })(window);